






import {Component} from "vue-property-decorator"
import AbpBase from "../../../lib/abpbase"

@Component
export default class Blood extends AbpBase{
	year = new Date()
	loading = false
	columns:any = [
		{title: ' ',width:160,fixed: 'left'},
		{
			title: '血透充分性指标',
			children:[
				{title: 'ERR≧65%',width: 130},
				{title: '1.2≤spKt/V≤1.4',width: 170},
				{title: 'URR≥65%且1.2≤spKt/V≤1.4',width: 260},
			]
		},
		{
			title: '体液、酸碱平衡与电解质指标',
			children: [
				{title: '体重增长率≤5%'},
				{
					title: 'CO2(mmol/L)',
					children: [
						{title: '<20',width: 130},
						{title: '20≦CO2≦26',width: 130},
						{title: '>26',width: 130},
					]
				},

			]
		},
		{
			title: '医疗质量指标',
			children:[
				{
					title: '透前血压(90/60-140/90mmHg)',
					children:[
						{title: '年龄≧60',width:130},
						{title: '年龄<60',width:130},
					]
				},
				{title:'ALB≥35g/L',width:130},
				{
					title:'HB(g/l)',
					children: [
						{title: '<110',width:130},
						{title: '110≤HB≤130',width:130},
						{title: '>130',width:130},

					]
				},
				{
					title:'IPTH(pg/ml)',
					children: [
						{title: '<300',width:130},
						{title: '300≤IPTH≤300',width:130},
						{title: '>600',width:130},
					]
				},
				{
					title:'Ca(mmol/L)',
					children: [
						{title: '<2.1',width:130},
						{title: '2.1≤IPTH≤2.5',width:130},
						{title: '>2.5',width:130},
					]
				},
				{
					title:'P(mmol/L)',
					children: [
						{title: '<1.13',width:130},
						{title: '1.13≤IPTH≤1.78',width:130},
						{title: '>1.78',width:130},
					]
				},
				{title:'10≤钙磷乘积≤55',width:130},
			]
		},
		{
			title: '患者透析时间例数统计',
			children: [
				{title:'患者平均透析时间(小时)',width:150},
				{title:'患者平均透析次数(n)',width:150},
			]

		}

	]
	data = []
	async created(){
		this.getData()
	}

	getData(){
		this.loading = true
		this.columns[0].title = this.year.getFullYear()
		setTimeout(()=>{
			this.loading = false
		},500)
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/dialysisQuality/index.vue